import { combineReducers } from 'redux';
import { details } from './details';
import { verification } from './verification';

export const account = combineReducers({
  details,
  verification,
});
